import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {DataTableDirective} from "angular-datatables";
import {BsModalRef, BsModalService} from "ngx-bootstrap";
import {abonnement, client, facture, type_client, type_piece} from "../../../../model/db";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthServiceService} from "../../../../service/auth-service.service";
import {HttpClient} from "@angular/common/http";
import {ToastrService} from "ngx-toastr";
import {HelperService} from "../../../../service/helper.service";
import {NgxUiLoaderService} from "ngx-ui-loader";
import {DataTablesResponse} from "../../../../model/DataTablesResponse";
import {environment} from "../../../../../../environments/environment";
import * as $ from "jquery";
import {valuesys} from "../../../../../../options";
import Swal from "sweetalert2";
import {Translatable} from "../../../../../Translatable";

@Component({
  selector: 'app-client',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.css']
})
export class ClientComponent extends Translatable implements OnInit {

  //DATATABLE
  //
  abonnements: abonnement[] =[ ]
  factures: facture[] =[ ]
  dtOptions2 : DataTables.Settings = {};
  dtOptions3 : DataTables.Settings = {};
  //

  title:string ;
  dtOptions: DataTables.Settings = {};
  modalRef: BsModalRef;
  titleModal:string ;
  isAdd : boolean = true ;
  isValid : boolean = false ;
  public clients :client[] = [] ;
  public client:client = new client();
  public type_clients:type_client [] = [];
  public type_pieces: type_piece [] = [];
  idtypeClientAdministration : number;
  idtypeClientEntreprise : number;
  public client_details: client;
  public client_error : client ;
  constructor(private activatedRoute: ActivatedRoute,
              private auth : AuthServiceService,
              private http: HttpClient,
              private httpClient: HttpClient,
              private toastr: ToastrService,
              private helper: HelperService,
              private modalService: BsModalService,
              private ngxService: NgxUiLoaderService,
              private route: Router
  ) {
    super();
  }

  async ngOnInit() {
    this.auth.initAutority("GCC");
    this.initDatatable();

  }
  initDatatable(){
    this.isAdd = true ;
    this.isValid = false ;
    this.title = this.__("client.client");
    this.dtOptions = this.helper.dataTableOption();
    this.dtOptions.columns = [
      {
        "data": "num_client"
      },{
        "data": "prenom"
      },
      {
        "data": "nom"
      },
      {
        "data": "telephone"
      },
      {
        "data": "email"
      },
      {
        "data": "typeClient",
        "name" : "typeClient.name",
      }
    ];
    this.dtOptions.ajax = (dataTablesParameters: any, callback) => {
      this.http
        .get<DataTablesResponse>(
          environment.client+"?child=typeClient&" + $.param(dataTablesParameters), valuesys.httpAuthOptionsProcess()
        ).subscribe(resp => {
        this.clients = resp.data;
        callback({
          recordsTotal: resp.recordsTotal,
          recordsFiltered: resp.recordsFiltered,
          data:[]
        });
      });
    }
  }
  initDatatableInfo(){
    this.dtOptions2 = this.helper.dataTableOption();
    this.dtOptions2.columns = [
      {
        "data": "num_compteur"
      },
      {
        "data": "date_abonnement"
      },
      {
      "data" : "state"
      }
      /*,
      {
        "data": "date_resiliation"
      }*/
    ];
    this.dtOptions2.ajax = (dataTablesParameters: any, callback) => {
      this.http
        .get<DataTablesResponse>(
            environment.abonnement+ "?child=typeAbonnement&where=client_id|e|"+ this.client_details.id+"&"+
            $.param(dataTablesParameters), valuesys.httpAuthOptionsProcess()
        ).subscribe(resp => {
         this.abonnements = resp.data;
        callback({
          recordsTotal: resp.recordsTotal,
          recordsFiltered: resp.recordsFiltered,
          data:[]
        });
      });
    };

    this.dtOptions3 = this.helper.dataTableOption();
    this.dtOptions3.columns = [
      {
        "data": "periode"
      },
      {
        "data": "num_facture"
      },
      {
        "data": "consommation"
      },

      {
        "data": "montant"
      },
      {
        "data": "date_paiement"
      },

      {
        "data": "abonnement",
        "name" : "abonnement.num_compteur",
      },
      {
        "data": "numero_transaction"
      },
    ];
    this.dtOptions3.ajax = (dataTablesParameters: any, callback) => {
      this.http
        .get<DataTablesResponse>(
            environment.facture+ "?child=abonnement&child_where=abonnement.client|id|e|"+ this.client_details.id+"&"+
            $.param(dataTablesParameters), valuesys.httpAuthOptionsProcess()
        ).subscribe(resp => {
         this.factures = resp.data;
        callback({
          recordsTotal: resp.recordsTotal,
          recordsFiltered: resp.recordsFiltered,
          data:[]
        });
      });
    }
  }
  async toggleState(client:client,state:number,btn:any,type='state'){

    btn.disabled = true;

    Swal.fire({
      title: this.__('swal.confirmTitle'),
      text: this.__('swal.confirmMsg'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: this.__('swal.no'),
      confirmButtonText: this.__('swal.yes')
    }).then(async (result) => {
      /*if (result.value) {
        Swal.fire(
          'swal.successTitle',
          'swal.success',
          'success'
        )
      }*/
      if (result.value) {
        let toogle = await this.http.get<any>(environment.client + `/${client.id}/${state}/${type}`, valuesys.httpAuthOptions()).toPromise();
        if (toogle.code == 201) {
          this.toastr.success(toogle.msg, this.__("msg.success"));
          client[type] = toogle.data[type]

        } else {
          this.toastr.error(toogle.msg, this.__("msg.error"));
        }
        btn.disabled = false;
      }
      btn.disabled = false;
    })



  }
  async toggleStateAbonnement(abonnement:abonnement,state:number,btn:any,type='state'){

    btn.disabled = true;

    Swal.fire({
      title: this.__('swal.confirmTitle'),
      text: this.__('swal.confirmMsg'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: this.__('swal.no'),
      confirmButtonText: this.__('swal.yes')
    }).then(async (result) => {
      /*if (result.value) {
        Swal.fire(
          'swal.successTitle',
          'swal.success',
          'success'
        )
      }*/
      if (result.value) {
        let toogle = await this.http.get<any>(environment.abonnement + `/${abonnement.id}/${state}/${type}`, valuesys.httpAuthOptions()).toPromise();
        if (toogle.code == 201) {
          this.toastr.success(toogle.msg, this.__("msg.success"));
          abonnement[type] = toogle.data[type]

        } else {
          this.toastr.error(toogle.msg, this.__("msg.error"));
        }
        btn.disabled = false;
      }
      btn.disabled = false;
    })



  }
  delete(deletedClient:client,elm){
    elm.disabled = true
    Swal.fire({
      title: this.__('msg.confirm'),
      text: this.__('msg.warning_delete'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.__('msg.confirmed_delete'),
      cancelButtonText: this.__('msg.cancel_delete')
    }).then(async (result) => {
      if (result.value) {
        let sup = await this.http.delete<any>(environment.client+"/" + deletedClient.id,valuesys.httpAuthOptions()).toPromise();
        // this.rerender();
        if(sup.code == 204){
          this.clients= this.clients.filter(function (item,index) {
            return item.id != deletedClient.id
          })
          Swal.fire(
            this.__('msg.deleted'),
            sup.msg,
            'success'
          )
        }else {
          this.toastr.error(sup.msg,this.__("msg.error"));
        }
        elm.disabled = false

      } else if (result.dismiss === Swal.DismissReason.cancel) {
        elm.disabled = false
        Swal.fire(
          this.__('msg.canceled'),
          this.__('msg.canceled_delete'),
          'error'
        )
      }
    })
  }
  async refreshPassword(client: client, elm) {
    elm.disabled = true
    console.log(client)
    Swal.fire({
      title: this.__('msg.confirm'),
      text: this.__('msg.warning_regener_password'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.__('msg.confirmed__regener_password'),
      cancelButtonText: this.__('msg.cancel_regener_password')
    }).then(async (result) => {
      if (result.value) {
        let sup = await this.http.get<any>(environment.clientRefreshPwd + '/' + client.id ,valuesys.httpAuthOptions()).toPromise();
        // this.rerender();
        if(sup.code == 201){
          Swal.fire(
            this.__('msg.regered_password'),
            sup.msg,
            'success'
          )
        }else {
          this.toastr.error(sup.msg,this.__("msg.error"));
        }
        elm.disabled = false
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        elm.disabled = false
        Swal.fire(
          this.__('msg.canceled'),
          this.__('msg.canceled_regered_password'),
          'error'
        )
        elm.disabled = false
      }
    })

  }
  async openModal(template:TemplateRef<any>,currenClient:client =null,elem) {
    this.type_pieces= await this.helper.getSelectList(environment.type_piece,['name']);
    this.idtypeClientEntreprise=environment.ID_TYPE_CLIENT_ENTREPRISE;
    this.idtypeClientAdministration=environment.ID_TYPE_CLIENT_ADMINISTRATEUR;
    this.client_error = new client()
    elem.disabled = true ;
    this.type_clients = await this.helper.getSelectList(environment.type_client,['name']);
    if(currenClient == null){
      this.isAdd = true ;
      this.client = new client() ;
      this.titleModal = this.__('client.add') ;
    }else {
      /*TEL*/
      this.currenCode = this.helper.getCodePaysByNum(currenClient.telephone.substr(0,3));
      /*TEL*/
      this.isAdd = false ;
      this.titleModal = this.__('client.edit') ;
      this.client = currenClient ;

    }
    elem.disabled = false ;
    this.modalRef = this.modalService.show(template,{class:"modal-md",ignoreBackdropClick:true});

  }
  close(){
    this.modalRef.hide()
    this.isValid = false ;
    this.client = new client()
    this.titleModal = this.__('client.edit') ;
    this.client_error = new client();
  }
  async addClientForm(){
    this.client_error = new client()
    this.isValid = true ;
    if(this.isAdd ){
      let res:any =  await this.http.post<any>(environment.client,this.client,valuesys.httpAuthOptions()).toPromise();
      if(res.code === 201){
        this.toastr.success(res.msg,this.__("msg.success")) ;
        res.data.typeClient = this.type_clients.find(_ => _.id == this.client.type_client_id) ;
        this.clients.push( res.data);
        this.close()
      }else if(res.code === 400){
        for (let item in res.data){
          this.client_error[item] = res.data[item][0] ;
        }
        this.client_error = <client> this.helper.errorForm(res.data);
        this.toastr.warning(res.msg,this.__("msg.warning")) ;
      }
      else {
        this.toastr.error(res.msg,this.__("msg.error")) ;
      }
    }else {
      console.log(this.client);
      let res =  await this.http.put<any>( environment.client + '/'+this.client.id,this.client,valuesys.httpAuthOptions()).toPromise();
      if(res.code === 201){
        this.client.typeClient = this.type_clients.find((_) =>_.id == this.client.type_client_id);
        this.toastr.success(res.msg,this.__("msg.success")) ;
        this.close()
      }else if(res.code === 400){
        this.client_error = <client> this.helper.errorForm(res.data);
        this.toastr.warning(res.msg,this.__("msg.warning")) ;
      }
      else {
        this.toastr.error(res.msg,this.__("msg.error")) ;
      }
    }
    this.isValid = false ;


  }
  async openModalDetails(template: TemplateRef<any>,currentClient:client =null,elm) {
    this.initDatatableInfo()
    elm.disabled = true
    this.titleModal = this.__('label_details') ;
    this.client_details = currentClient
    console.log(this.client_details)
    this.modalRef = this.modalService.show(template,{class:"modal-lg",ignoreBackdropClick:true});
    elm.disabled = false
  }
  /*telephone */
  objetPhone : any ;
  onCountryChange(m){
    let lastDiall =  this.objetPhone .dialCode ;
    let newDiall = m.dialCode
    console.log(`LAST = ${lastDiall} ; NEW ${newDiall}`,m);
    this.element.value = this.element.value.replace(lastDiall+'',newDiall+'');
    this.objetPhone = m ;
    /*Changed*/
    this.client.telephone = this.element.value
    /*Changed*/
  }
  telInputObject(m){
    this.objetPhone = m.s ;
  }
  element : any ;
  currenCode :string =environment.CURREN_CODE_COUNTRY;
  controle(element){
    this.element = element ;
    element.value = element.value.replace(/[^0-9]/gi,'');
    if((element.value || "").substr(0,this.objetPhone.dialCode.length).indexOf(this.objetPhone.dialCode.toString()) == -1){
      if(element.value.length <=  this.objetPhone.dialCode.length  && (element.value || "").substr( this.objetPhone.dialCode.length ).length < 1)
      {
        element.value =  this.objetPhone.dialCode;
      }
      else
      {
        if((element.value || "").substr(0,this.objetPhone.dialCode.length ).indexOf( this.objetPhone.dialCode.toString()) !== -1){
          element.value =  element.value;
        }
        else {
          element.value = this.objetPhone.dialCode +  element.value;
        }
      }
    }
    /*Changed*/
    this.client.telephone = element.value;
    /*Changed*/
  }
  /*telephone */

  loadItem(btninfo: HTMLAnchorElement, info: string) {
    $(".marker a").removeClass('activeTab')
    btninfo.classList.add('activeTab')


  }
  changer(reftype){
    this.client.type_client_id=  +reftype.element.val();
    // console.log(typeof this.client.type_client_id,typeof this.idtypeClientEntreprise, typeof this.idtypeClientAdministration);
  }

  async exportExcel(btnExcel) {
    btnExcel.disabled = true
    await this.helper.exportExcel(this.print(this.clients),this.__("print.list") + this.__("client.clients"));
    btnExcel.disabled = false
  }

  print(client:client[]){
    return  client.map((client)=>{
      let t = {}
      t[this.__('client.no_client')] = client.num_client 
      t[this.__('client.prenom')] = client.prenom
      t[this.__('client.nom')] = client.nom
      t[this.__('client.telephone')] = client.telephone
      t[this.__('client.email')] = client.email
      t[this.__('type_client.type_client')] = client.typeClient.name 
      t[this.__('label_state')] =  (client.state == 0 ? this.__("tooltip.desactiver") : this.__("tooltip.active"))
      return t ;
    })  || [];

  }
  

}
